<router-outlet></router-outlet>
<!-- <div class="change-theme-button" (click)="toggleTheme()">
    <i nz-icon nzType="format-painter" nzTheme="outline"></i>
</div> -->
<vss-ui-loading></vss-ui-loading>
